module.exports = __webpack_public_path__ + "static/01 - MIT.svg-8a13bbacd75912d74e584846d9c293f3.png";